import classNames from 'classnames';
import { isBoolean, isString, isUndefined } from 'lodash';
import React from 'react';
import { Loading } from '@meitu/saas-ui';
import { useLocaleStore } from '@/i18n';
import { PluginType, type IExportPlugin } from '@/version-types';
import { BaseViewportPlugin } from '../../components';
import { getFramework } from '../../framework';
import { useGlobalMask, useIdentity, useViewSize } from '../../hooks';
import './index.less';

/** 全局遮罩 */
const MaskLoading: React.FC = React.memo(() => {
    const identity = useIdentity();
    const framework = getFramework(identity);
    const { width: viewWidth, height: viewHeight } = useViewSize();
    const globalMask = useGlobalMask();
    const { $t } = useLocaleStore();

    if (!globalMask) return null;

    const backgroundStyle = isString(globalMask.background)
        ? {
              background: globalMask.background,
          }
        : {};
    const blindAreas = framework.service.edgelessCanvas.blindAreas;

    return (
        <div
            onMouseDown={(e) => {
                e.preventDefault();
                e.stopPropagation();
            }}
            className={classNames('mask-loading-wrap', {
                'mask-background': isBoolean(globalMask.background) ? globalMask.background : false,
            })}
            style={backgroundStyle}
        >
            <BaseViewportPlugin name="mask-loading">
                <div
                    className={classNames('mask-loading')}
                    style={{
                        transform: `translate(${(viewWidth + blindAreas.left - blindAreas.right) / 2}px, ${(viewHeight + blindAreas.top - blindAreas.bottom) / 2}px)`,
                    }}
                >
                    {globalMask.loading ? (
                        <Loading
                            style={{ width: 100, height: 100, transform: 'translate(-50%, -50%)' }}
                            tip={isUndefined(globalMask.text) ? $t((v) => v.globalMask.loading) : globalMask.text}
                        />
                    ) : null}
                </div>
            </BaseViewportPlugin>
        </div>
    );
});

const exportPlugin: IExportPlugin = {
    type: PluginType.VIEWPORT,
    sort: 2,
    name: 'mask-loading',
    render() {
        return <MaskLoading />;
    },
};

export default exportPlugin;
